<template>
    <ToolButton :Editor="Editor" KnownIcon="Bold" @ToolClick="Editor.chain().focus().toggleBold().run()" 
        :class="{ 'toggled': Editor.isActive('bold') }">

    </ToolButton>
</template>
<script>

    import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

    export default({
        components:{
            ToolButton
        },
        props:["Editor"]
    });
</script>